module.exports = "/images/maleta-01.png?8dc2dd772d0e96bb703818eff158b04d";


//////////////////
// WEBPACK FOOTER
// ./resources/images/assets2020/maleta-01.png
// module id = FX4K
// module chunks = 0